import {createApi} from '@reduxjs/toolkit/query/react';

import {teasBaseQuery} from '../baseQuery/teasBaseQuery';

export const omneticApi = createApi({
  baseQuery: teasBaseQuery,
  reducerPath: 'rtk_omneticApi',
  tagTypes: [
    'AiVehicleServiceIntervals',
    'Interest',
    'interestPriceReport',
    'InterestPriceReportPreview',
    'InterestActivity',
    'InterestFutureActivity',
    'InterestCount',
    'EmailCredentials',
    'AuditData',
    'PurchaseFunnel',
    'MultiFactorAuthentication',
    'EmailSignature',
    'SaleFunnel',
    'VehicleStockOverview',
    'LatestVehiclesList',
    'BillingInformation',
    'BillingInformationList',
    'DocumentTemplates',
    'RentalSettings',
    'AiLeadSettings',
    'GeneralSettingsBranch',
    'GeneralSettingsTenant',
    'customFieldList',
    'CustomFieldProperty',
    'LatestInterestsList',
    'LatestBusinessCasesList',
    'ServiceCase',
    'RentalPriceGroup',
    'RentalOrder',
    'TestDrive',
    'VehicleTestDrives',
    'VehicleTestDrivesV1',
    'BusinessCaseTestDrive',
    'ServiceAlbumPhotoList',
    'RentalVehicle',
    'Roles',
    'deviceList',
    'MandatoryFields',
    'MandatoryFieldsSequence',
    'windshield',
    'entityCustomFields',
    'watermark',
    'balanceInvoice',
    'notificationSettings',
    'transaction',
    'PriceReport',
    'dueDatesDetail',
    'dueDates',
    'EsignoService',
    'preAccountingProcessing',
    'correctiveDocumentSetting',
    'TaxDocumentSettingList',
    'Vehicle',
    'VehicleServiceIntervals',
    'EmployeePhoto',
    'signDocumentTransaction',
    'vehiclePriceReport',
    'vehicleInsurance',
    'invoiceProformaPaymentList',
    'cashRegisters',
    'cashRegisterLimitDefinition',
    'DocumentSeriesDefinition',
    'GeneralSeries',
    'UserMenuPins',
    'DashboardSettings',
    'CurrentUser',
    'OtherUserSettings',
    'offer',
    'OfferSetting',
    'paymentPrescription',
    'shortcomings',
    'VehiclePhotos',
    'VehicleAlbumPhotos',
    'highlights',
    'invoiceProforma',
    'User',
    'Users',
    'Tenant',
    'EmailConfig',
    'Branch',
    'BranchList',
    'cancellationDefinition',
    'marginDefinitions',
    'proformaGeneration',
    'CebiaAutotracerAndReportConfig',
    'CebiaFeatureDecoderConfig',
    'CebiaRokvyConfig',
    'CebiaVinDecoderConfig',
    'OmneticVinDecoderConfig',
    'WhatsAppConfig',
    'OutlookConfig',
    'JbrConfig',
    'onlineOfferSettings',
    'roundingDefinitions',
    'invoicePayment',
    'InvalidDocumentRegister',
    'KonzultaConfig',
    'EuVies',
    'DistraintRegister',
    'invoice',
    'InsolvencyRegister',
    'UnreliableVatPayerRegister',
    'VehicleFinanceSummary',
    'VehicleCosts',
    'VehicleEarnings',
    'SaleVehicle',
    'QrCodeSettings',
    'SaleVehicleFlags',
    'SaleVehicleCost',
    'SaleVehicleEarning',
    'SaleVehicleWatermarkPreview',
    'correctiveTaxDocument',
    'SaleVehicleCostPreset',
    'SaleVehicleEarningPreset',
    'photoSettings',
    'promotionalPhoto',
    'miniSale',
    'miniPurchase',
    'supportedPlatforms',
    'promotionalPhotoVehicle',
    'participation',
    'GdprConsentType',
    'GdprConsent',
    'documentContext',
    'dgv4-preset',
    'dgv4-smart-search',
    'customerNote',
    'customerComments',
    'Customer',
    'Customers',
    'Checkout',
    'CustomerNote',
    'AutoFillTemplates',
    'CentralizedPricing',
    'Inspection',
    'upsellProductItem',
    'businessCaseUpsell',
    'Complaint',
    'VehicleComplaints',
    'SaleVehicleComplaints',
    'commissionRule',
    'permissions',
    'BCList',
    'VehicleLastActiveBC',
    'EntityTagList',
    'tenantTagList',
    'CustomerVerificationRegisters',
    'InspectionTemplates',
    'Codelist',
    'CustomerRequestedPrice',
    'CashRegisterDocument',
    'SourcingFilterPresetList',
    'SourcingFilterPreset',
    'vehicleWarehouse',
    'vehicleWarehouseForMovement',
    'vehicleWarehouseSettings',
    'vehicleWarehouseInformation',
    'vehicleWarehousesByUser',
    'vehicleWarehousesByBranch',
    'vehicleWarehouseSummary',
    'AdGeneralSettings',
    'AdPlatformSettings',
    'AdWindshieldSettings',
    'PredefinedNotes',
    'BusinessCaseDetail',
    'BusinessCaseCount',
    'BusinessCaseActions',
    'BusinessCaseActivity',
    'BusinessCaseFutureActivity',
    'BusinessCaseCountByVehicle',
    'BusinessCaseSalePrices',
    'BusinessCasePurchasePrices',
    'VatCheckTotalsDefinition',
    'note',
    'VehicleNote',
    'VehicleFinancialInstitution',
    'documentsCount',
    'comments',
    'ChatSettings',
    'BusinessCaseMessageChannel',
    'InterestMessageChannel',
    'comment',
    'InspectionList',
    'CebiaSmartCodeUrlConfig',
    'Notification',
    'MessageTemplate',
    'MessageTemplates',
    'SchedulerRuns',
    'backgroundRemovalSettings',
    'LocaleConfig',
    'SalesFinanceSettings',
    'PublishingPlatformSauto',
    'PublishingPlatformTipcars',
    'PublishingPlatformMobileDe',
    'PublishingPlatformMyWeb',
    'PublishingPlatformFacebook',
    'PublishingPlatformAutocaris',
    'PublishingPlatformSkodaPlus',
    'PublishingPlatformDasWeltAuto',
    'PublishingPlatformMercedesNaSklade',
    'PublishingPlatformHyundaiPromise',
    'PublishingPlatformOtomoto',
    'PublishingPlatformFordUzywane',
    'PublishingPlatformAutoplacPl',
    'PublishingPlatformVehis',
    'PublishingPlatformMamGo',
    'PublishingPlatformFordGeronimo',
    'PublishingPlatformSamochodyPl',
    'PublishingPlatformFindCarPl',
    'SourcingAllListsWithSameResponseStructure',
    'SourcingAuctionAllListsWithSameResponseStructure',
    'SourcingAuctionList',
    'SourcingAuctionDetail',
    'SourcingFavouriteList',
    'SourcingHiddenList',
    'SourcingToBuyList',
    'SourcingCarvagoBuyList',
    'SourcingComparisonList',
    'SourcingVehicleList',
    'SourcingVehicleDetail',
    'SourcingPriceMapVehicles',
    'SourcingComments',
    'SourcingVehicleCosts',
    'SourcingPriceMap',
    'storageSector',
    'storageOccupiedSpace',
    'storageOccupiedSpaces',
    'storageSectors',
    'BusinessCaseSettings',
    'SaleVehicleActions',
    'SaleVehicleAlbumPhotos',
    'SaleVehicleAlbums',
    'SaleVehiclePromoPhotos',
    'SaleVehicleCoverPhoto',
    'TipCarsDefaultSettings',
    'SAutoDefaultSettings',
    'miniPurchase',
    'BulkEvent',
    'SalePreset',
    'GeneralSettingsTenant',
    'OfferedCars',
    'VehicleReservationHistory',
    'VehicleActiveReservation',
    'VehiclePriceSnapshots',
    'TopMakes',
    'ServiceVehicleHomeService',
    'WatermarkDetial',
    'WatermarkList',
    'PlatformList',
    'Task',
    'TaskCounter',
    'TaskList',
    'CorrectiveDocumentSettingList',
    'ChecklistDefinition',
    'GetAssignments',
    'SearchAssignmentUsers',
    'InterestAssignmentCondition',
    'DataGrid',
    'Checklist',
    'CarVerticalConfig',
    'CarVerticalReports',
    'KanbanUsers',
    'CalendarUsers',
    'QuickPreset',
    'SimilarVehiclesCount',
    'OutlookCalendars',
    'Team',
    'CalendarIntegration',
    'CustomTenantCatalogue',
    'AutotracerPlReport',
    'WorkshopInterest',
    'WorkshopInterestSeriesDefinition',
    'WorkshopInterestSeriesDefinitions',
    'VehicleInsights',
    'CarpassConfig',
  ],
  endpoints: () => ({}),
});
